export default function allowed() {
	return Tools.FeatureHelper.hasSoftDeployAccess('CALL_LISTS');
}
